import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEIncomeCardActions = {
  initPeIncomeCard: ({ commit }) => {
    commit('setPeIncomeCardLock', true)
  },
  PeIncomeCardRefresh: async ({ commit, dispatch, getters }) => {
    const party = getters.peParty

    dispatch('peChildrenIncomeRefreshAll')
    dispatch('peMarriagesdIncomeRefreshAll')
    dispatch('peParentsIncomeRefreshAll')
    dispatch('peSiblingsIncomeRefreshAll')

    return axiosRequest.
      get(`/parties/${party.id}`).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeIncomeCardLock', true)
        commit('pePatchParty', {
          monthly_household_income_estimated: updatedParty.monthly_household_income_estimated,
          monthly_income: updatedParty.monthly_income,
          income_verification: updatedParty.income_verification,
        })
      }).
      catch(handleError)
  },
  PeIncomeCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        monthly_household_income_estimated: section.monthly_household_income_estimated,
        monthly_income: section.monthly_income,
        income_verification: section.income_verification,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeIncomeCardLock', true)
        commit('pePatchParty', {
          monthly_household_income_estimated: updatedParty.monthly_household_income_estimated,
          monthly_income: updatedParty.monthly_income,
          income_verification: updatedParty.income_verification,
        })
      }).
      catch(handleError)
  },
}

export const PEIncomeCardMutations = {
  setPeIncomeCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'IncomeCard', lock)
  },
}

export const PEIncomeCardGetters = {
  PeIncomeCardLock: state => state.partyEdit.partySections.IncomeCard,
}
